import PcbContainer from './containers/PcbContainer'

// Sync route definition
export default {
  path      : '/pcb/:device_string',
  component : PcbContainer
}



// WEBPACK FOOTER //
// ./src/routes/PCB/index.js